// Override WSG price blurring for approved customers
(function() {
  'use strict';
  
  // Function to remove WSG blur effects
  function removeWSGBlur() {
    // Remove the WSG blur style element
    const wsgBlurStyle = document.getElementById('wsg-prices-blur');
    if (wsgBlurStyle) {
      wsgBlurStyle.remove();
    }
    
    // Remove blur from any price elements
    const priceElements = document.querySelectorAll('[class*="price"], .money, [data-price]');
    priceElements.forEach(function(el) {
      el.style.filter = 'none';
      el.style.webkitFilter = 'none';
      el.style.opacity = '1';
      el.style.visibility = 'visible';
    });
  }
  
  // Run immediately
  removeWSGBlur();
  
  // Monitor for WSG trying to add blur styles back
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.type === 'childList') {
        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType === 1 && node.id === 'wsg-prices-blur') {
            node.remove();
          }
        });
      }
    });
  });
  
  // Start observing
  if (document.head) {
    observer.observe(document.head, { childList: true });
  }
  
  // Also run periodically to catch any missed changes
  setInterval(removeWSGBlur, 500);
  
})();